import { render, staticRenderFns } from "./BonusPointRuleList.vue?vue&type=template&id=2fef5341&"
import script from "./BonusPointRuleList.vue?vue&type=script&lang=js&"
export * from "./BonusPointRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports